var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{staticClass:"propertyValue",attrs:{"disabled":!_vm.isEditable,"size":"mini"},on:{"change":_vm.saveChange},model:{value:(_vm.intValue),callback:function ($$v) {_vm.intValue=$$v},expression:"intValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }